import { frontendURL } from '../../../helper/URLHelper';

// Editor visual de flow (vue-flow). Vive em rota top-level pois precisa de
// tela cheia. A lista/configuração administrativa fica em
// /settings/agent-bots - ver routes/dashboard/settings/agentBots/.
const AgentBotEditor = () => import('./Editor.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/agent_bots/:id/flow'),
      name: 'agent_bot_editor',
      component: AgentBotEditor,
      meta: { permissions: ['administrator'] },
      props: true,
    },
  ],
};
